import {
  afterRender,
  Component,
  computed,
  EventEmitter,
  HostBinding,
  inject,
  input,
  Output,
  signal,
  viewChild
} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {faAngleDown, faAngleUp} from '@fortawesome/free-solid-svg-icons';
import {TrackEventService} from '@core/services/track-event.service';

@Component({
  selector: '[app-read-more]',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.scss'],
  imports: [
    NgTemplateOutlet
  ]
})
export class ReadMoreComponent {
  private trackEventService = inject(TrackEventService);

  useReadMore = input<boolean>(false);
  showFadeOut = input<boolean>(false);
  backgroundColor = input<string>('#ffffff');

  useBootstrapClasses = input<boolean>(false);

  readMoreText = input<string>($localize`Læs mere`);
  readLessText = input<string>($localize`Læs mindre`);

  isBodyLong = signal(false);
  isBodyExpanded = signal(false);

  maxBodyHeight = input<number | undefined>();

  maxHeight = this.getMaxHeightSignal();
  background = computed(() => `linear-gradient(rgba(255, 255, 255, 0), ${this.backgroundColor()})`);

  eventSourceName = input<string | undefined>(undefined);

  @Output() toggleReadMore = new EventEmitter<boolean>();

  @HostBinding('class.read-more-body-expanded')
  get readMoreBodyExpandedClass() {
    return this.isBodyExpanded();
  }

  readonly bodyWrapper = viewChild<any>('bodyWrapper');
  readonly bodyContent = viewChild<any>('bodyContent');
  protected readonly faAngleDown = faAngleDown;
  protected readonly faAngleUp = faAngleUp;

  constructor() {
    afterRender({
      read: () => {
        if (this.useReadMore()) {
          this.isBodyLong.set(this.checkBodyLong());
        }
      }
    });
  }

  getMaxHeightSignal() {
    return computed(() => {
      if (this.isBodyExpanded() || !this.maxBodyHeight()) {
        return 'none';
      }
      return this.maxBodyHeight() + 'px';
    });
  }

  checkBodyLong() {
    const bodyContent = this.bodyContent();
    const bodyWrapper = this.bodyWrapper();
    if (!bodyContent || !bodyWrapper) {
      return false;
    }
    const bodyContentHeight = bodyContent.nativeElement.clientHeight;
    const bodyWrapperHeight = bodyWrapper.nativeElement.clientHeight;
    if (bodyContentHeight === 0) {
      return false;
    }

    return bodyContentHeight > bodyWrapperHeight;
  }

  toggleBody() {
    this.isBodyExpanded.set(!this.isBodyExpanded());
    this.toggleReadMore.emit(this.isBodyExpanded());
    this.trackEventService.trackEvent('click', {
      clickEvent: this.isBodyExpanded() ? 'Read More' : 'Read Less',
      eventSourceName: this.eventSourceName()
    });
  }
}
